const getBackendUrl = () => {
  if (typeof window !== "undefined") {
    const hostname = window.location.hostname;
    if (hostname === "localhost" || hostname === "127.0.0.1") {
      return "http://localhost:8000";
    }
  }
  return "/_/backend";
};

// Force relative backend URL in production to prevent environment variables from pointing to an old separate deployment instance
export const BACKEND_URL = getBackendUrl();
export const API_URL = `${BACKEND_URL}/api`;

export const getMediaUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  
  if (url.startsWith("/_/backend")) {
    if (BACKEND_URL.includes("localhost") || BACKEND_URL.includes("127.0.0.1")) {
      return `${BACKEND_URL}${url.replace("/_/backend", "")}`;
    }
    return url;
  }
  
  if (url.startsWith("/uploads")) {
    return `${BACKEND_URL}${url}`;
  }
  
  return url;
};
